import { Pipe, PipeTransform } from '@angular/core';

const IMAGE_MAP: Record<string, Record<string, Record<string, string>>> = {
  frecuency: {
    DESCRIPCIÓN: {
      Valor: 'details_car_subcuenta.png',
    },
    FRECUENCIA: {
      MENSUAL: 'details_car_estado_vehiculo_moviendo.png',
      QUINCENAL: 'details_car_estado_vehiculo_moviendo.png',
      SEMANAL: 'details_car_estado_vehiculo_moviendo.png',
      ANUAL: 'details_car_estado_vehiculo_moviendo.png',
    },
    TIPO_DE_RUTA: {
      PREVENTA: 'details_car_estado_vehiculo_detenido.png',
      VENTA: 'details_car_bloqueable.png',
      POSVENTA: 'carcharger.png',
    },
    DIA_DE_LA_VISITA: {
      LUNES: 'details_car_alias.png',
      MARTES: 'details_car_alias.png',
      MIÉRCOLES: 'details_car_alias.png',
      JUEVES: 'details_car_alias.png',
      VIERNES: 'details_car_alias.png',
      SÁBADO: 'details_car_alias.png',
      DOMINGO: 'details_car_alias.png',
    },
    FRECUENCIA_MENSUAL: {
      Q1: 'details_car_ultima_actualizacion.png',
    },
    TERRITORIO: {
      Valor: 'details_car_coordenadas.png'
    }
  },
};

@Pipe({ name: 'frecuencyIcons' })
export class FrecuencyIconsPipe implements PipeTransform {
  transform(category: string, property: string, value: string): string {
    const normalizedValue = value.replace(/\s/g, '_')?.toUpperCase();
    const normalizedProperty = property.replace(/\s/g, '_').toUpperCase();
    return IMAGE_MAP[category]?.[normalizedProperty]?.[normalizedValue] || IMAGE_MAP[category]?.[normalizedProperty]?.['Valor'] || 'detail_Default.svg';
  }
}